import Axios from 'axios';
import Vue from 'vue';
import VueRouter from 'vue-router';

import {
	apiURL,
	replaceToken
} from './../config/js/setConfig.js';

import {
	setCookie,
	getCookie,
	delCookie
} from './../config/js/handleCookie.js'




let vue = new Vue;
let router = new VueRouter();

let base = '';
  base = apiURL;
let axios = Axios.create({
	//	 headers: {'Content-Type': 'application/json'},
	baseURL: base
});

//请求
//axios.interceptors.request.use(
//config => {
//  return config;
//},
//err => {
//  return Promise.reject(err);
//});

//请求
axios.interceptors.request.use(
	config => {

        let token = getCookie('token')
//		let token = replaceToken()

		if(token) {
			//config.headers.token = token;
			config.headers['originoo-authorization'] = token;
		}
		return config;
	},
	err => {
		return Promise.reject(err);
	});

//响应
axios.interceptors.response.use(
	response => {

		if(response.status == 200) {

		} else {
			vue.$message.error(response.data.message)
		}
		return response;
	},
	error => {
		//console.log(error.response.request,'444545')

		//console.log(error.config, 'error.config')
		//console.log(error.response, 'error.response')

		if(error.response) {

			if(error.response.status == 403){

				vue.$message.error('请登录')
				//window.location.reload();

			}else{

				if(error.response.data.message){
					vue.$message.error(error.response.data.message)
				}else{
					vue.$message.error(error.response.data.error)
				}
			}
		} else {
			vue.$message.error(error.message)
		}
		return Promise.reject(error);
	});

/* API命名格式 */
/**
 *  请求方式 + 自定义名 + 请求类型 （例. getCourseList）
 *  请求方式：get请求为get，post请求为post
 *  自定义名：根据情况自己定义(最好使用接口名)
 *  请求类型：获取列表跟List，添加跟Add, 编辑跟Update，删除跟Delete
 */

//get请求
//export const getLectureList = params => {
//var token = getToken();//微信获取token
//return axios.get(`${admin}user/getLecturers?token=${token}`, {params})
//}
//post请求
//export const postAddTrainingNeeds = params => {
//var token = getToken();
//return axios.post(admin + `trainingDemand/store?token=${token}`, params)
//}
//delete请求
//export const deleteTrainingNeeds = params => {
//var token = getToken();
//return axios.delete( `trainingDemand/delete/${params.id}`, {params})
//}

//function getToken() {
//	var token = '';
//	var user = localStorage.getItem('user');
//	user = JSON.parse(user);
//	if(user) {
//		token = user.token;
//	}
//	return token;
//}

//登录
export const postLogin = params => {
	return axios.post(`login`, params)
}
//获取注册和忘记密码的图片验证码
//export const getPicCode = params => {
//	axios.interceptors.response.responseType = 'arraybuffer';
//  return axios.get(`register/imageCode`, {params})
//}


//注册其他信息
export const postRegotherInfo = params => {
	return axios.post(`account/information/register`, params)
}

//腾讯云上传接口
export const getUploadTencentToken = params => {
	return axios.get(`tencent/uploadedToken/${params.path}`, {
		params
	})
}

//免费搜索接口
export const getFreeSearchList = params => {
	return axios.get(`freepic/list/${params.page}/${params.size}`, {
		params
	})
}
//免费详情接口
export const getFreeImage = params => {
	return axios.get(`freepic/${params.id}`, {
		params
	})
}
//免费会员支付
export const postFreeVIPPayment = params => {
	return axios.post(`freepic/insertFreeVipOrder`, params)
}

//查询微信支付状态

export const getWXPayStatus = params => {
	return axios.get(`balance/getOrderStatus`, {
		params
	})
}






//免费下载
export const postFreeDownload = params => {
	return axios.post(`freepic/download`, params)
}
//免费会员到期时间
export const getFreeVipTime = params => {
	return axios.get(`freepic/lasttime`, {
		params
	})
}

//获取de图片search
export const getDESearchList = params => {
	return axios.get(`pic_search/setsearch`, {
		params
	})
}
//获取dt图片搜索
export const getDTSearchList = params => {
	return axios.get(`pic_search/dmstsearch`, {
		params
	})
}

//获取本地图片搜索
export const getORSearchList = params => {
	return axios.get(`originpic/search`, {
		params
	})
}
//获取收藏夹列表
export const getCollectionList = params => {
	return axios.get(`collection/list`, {
		params
	})
}
//判断是否收藏
export const getIsCollect = params => {
	return axios.get(`favorite/exist`, {
		params
	})
}

//获取收藏夹列表 -- 传图片id 返回值 判断是否收藏
export const getJudgeListOrCancel = params => {
	return axios.get(`collection/valid`, {
		params
	})
}

//新增收藏夹
export const postNewCollection = params => {
	return axios.post(`collection`, params)
}
//添加收藏   search 页面用
//export const postAddCollection = params =>{
//	return axios.post(`favorite`, params)
//}

//添加收藏
export const postAddCollection = params => {
	return axios.post(`favorite/batchFavorite`, params)
}
//批量收藏
export const postBatchCollection = params => {
	return axios.post(`favorite/batchFavorite`, params)
}

//取消收藏
export const postCancelCollection = params => {
	return axios.post(`favorite/deleteByImageId`, params)
}




//
//添加喜欢 取消喜欢
///account/likes
export const postAddCancelLike = params => {
	return axios.post(`account/likes`, params)
}

//问题反馈
export const problemFeedback = params => {
	return axios.post(`feedback`, params)
}

//问题反馈  陈伟
export const problemFeedbackNew = params => {
	return axios.post(`feedback/createTopic`, params)
}



//价格页面
//获取套餐
export const getTCList = params => {
	return axios.get(`subscription/lists?status=normal&isShow=1`, {
		params
	})
}
//获取套餐——活动
export const getTCList_activity = params => {
	return axios.get(`subscription/promotion`, {
		params
	})
}
//获取用户可用套餐
export const getAccountSubscriptions = params => {
	return axios.get(`account/subscription/list/all`, {
		params
	})
}

//获取用户信息

export const getUserInfo = params => {
	return axios.get(`account/information`, {
		params
	})
}

//个人中心
//下载记录 -- 获取下载记录
export const getDownloadList = params => {
	return axios.get(`account/downloads/pageable`, {
		params
	})
}

//获取购物车页面内的可用套餐
export const getUsableTcList = params => {
	return axios.get(`account/subscription/list`, {
		params
	})
}

//获取购物车记录
export const getShoppingCart = params => {
	return axios.get(`shoppingcar`, {
		params
	})
}

//监听购物车授权方式和尺寸的变化
export const postTypeEmpowerChange = params => {
	return axios.post(`shoppingcar/${params.id}`, params)
}

//购物车删除
export const postDelCart = params => {
	return axios.post(`shoppingcar/drop`, params)
}
//购物车购买
export const postCartSettlement = params => {
	return axios.post(`shoppingcar/buy`, params)
}

//添加到购物车
export const putShoppingCar = params => {
	return axios.put(`shoppingcar`, params)
}
//修改购物车
export const postShoppingCar = params => {
	return axios.post(`shoppingcar/${params.id}`, params)
}




/****************************************************/
//获取所有优惠券
export const getAllCouponList = params => {
	return axios.get(`account/coupons`, {params})
}
//获取余额
export const getBanlance = params => {
	return axios.get(`balance/getBalance`, {params})
}
//获取套餐详情
export const getTCInfo = params => {
	return axios.get(`subscription/${params.code}`, {params})
}
//提交订单
export const postAddOrder = params => {
	return axios.post(`order/subscription`, params)
}
//兑换优惠码
export const getChangeCode = params => {
	return axios.get(`account/coupon/code`, {params})
}
//获取订单详情
export const getOrderDeatil = params => {
	return axios.get(`order/${params.code}`, {params})
}
//订单详情立即支付
export const postbuyNow = params => {
	return axios.post(`order/subscription/settle`, params)
}
//取消订单
export const postCancelOrder = params => {
	return axios.post(`order/drop/${params.code}`, params)
}


/*****************1213 main************************/
//atlas 获取
export const getAtlasList = params => {
	return axios.get(`favorite/list/pageable`, {params})
}



/*****************1213 main************************/



//获取站内信的未读消息数量
export const postUserUnreadMsgNum = params => {
	return axios.post(`message/countMessage`, params)
}
//获取购物车数量
export const postShopCartNum = params =>{
	return axios.post(`shoppingcar/countShoppingCar`, params)
}


//高端购买
export const postGradeBuy = params => {
	return axios.post(`upscale/buy`, params)
}

//高端获取图片详情信息
export const getGradePicInfo = params => {
	return axios.get(`upscale/${params.id}`, {params})
}

//获取视频相似

export const getVideoSimilar = params => {
	return axios.get(`external/us/similar`, {params})
}


//翻译

export const translateEN = params => {
	return axios.get(`translate/doTranslate`, {params})
}

//获取高端作者其他

export const getGradeAuthorOthor = params => {
	return axios.get(`upscale/list/${params.page}/${params.size}`, {params})
}



//添加浏览记录

export const postAddBrowseRecord = params => {
	return axios.post(`account/scan`, params)
}




//搜索高端对应作者的图片  在高端作者其他页面
export const getGradeAuthorSearch = params => {
	return axios.get(`upscale/list/${params.page}/${params.size}`, {params})
}


//立即支付校验
export const getPayStatus = params => {
	return axios.get(`balance/getOrderStatusById`, {
		params
	})
}

//获取发票详情

export const getInvoiceDetail = params => {
	return axios.get(`receipt/getAccountReceipt`, {
		params
	})
}
//获取图集名称
export const getAtlasName = params => {
	return axios.get(`/collection/${params.id}`, {
		params
	})
}
//获取DE作者其它图片
export const getDeAuthorOthor = params => {
	return axios.get(`external/us/auth`, {params})
}

//获取DE相似图片

export const getDeSimilar = params => {
	return axios.get(`external/us/similar`, {
		params
	})
}
//获取作者其他图片 or 本地
export const getOrAuthorOthor = params => {
	return axios.get(`originpic/searchByAuther`, {params})
}


//获取DT相似图片列表
export const getDTsimilar = params => {
	return axios.get(`external/eu/similar`, {params})
}

//获取de 相似相关  -- 图片和视频的同组和模特
export const deRelevant = params => {
	if(params.type=="author"){
		return axios.get(`external/us/auth`, {params})
	}else{
		return axios.get(`external/us/similar`, {params})

	}

}












//获取音乐列表 search
export const getMusicSearchList = params => {
	return axios.get(`music/list/pageable`, {params})
}






//获取音乐详细信息的接口
export const getMusicInfoByid = params => {
	return axios.get(`music/${params.id}`, {
		params
	})
}
//获取音乐试听信息的接口  下载
export const getPreviewInfo = params => {
	return axios.get(`music/preview/${params.id}`, {
		params
	})
}


//获取作者信息的接口
export const getAuthorInfo = params => {
	return axios.get(`music/producer`, {
		params
	})
}


//获取音乐详细定价  //加入购物车时使用
export const getmusicPrice = params => {
	return axios.get(`music/price/${params.id}`, {
		params
	})
}

//音乐添加到收藏夹
export const postMusicAddFav = params =>{
  return axios.post(`favorite/music`, params)
}


//音乐付款
export  const postMusicPayMoney = params =>{
   return axios.post('order/music/settle',params)
}

//音乐添加到收藏夹 批量收藏
export const postMusicBatchAddFav=params =>{
  return axios.post(`favorite/musicBatch`, params)
}
//音乐购买 --生成订单
export const postMusicCartSettlement=params =>{
  return axios.post(`order/music/shoppingcar`, params)
}



// WEBPACK FOOTER //
// ./src/api/api.js